import React from 'react';
import PageMeta from '../../components/common/PageMeta';
import SassMarketingFeature from "../../components/sassMarketing/SassMarketingFeature.js";
import Subscription from "../../components/sassMarketing/SassMarketingSubscription.js";
import HeroSeventeen from '../../components/sassMarketing/HeroSeventeen.js';
import FooterSocial from '../../layout/Footer/FooterSocial';
import NavbarWms from '../../layout/Header/Navbar_Wms';
import Layout from '../../layout/Layout';
import HelpDeskFaq from "../../components/helpDeskHome/HelpDeskFaq.js"
import NavbarTop from "../../layout/Header/Navbar";
import FooterOne from '../../layout/Footer/FooterOne.js';
import WmsCard from "./WmsCard.js"
import Features from "./Features.js";
import WhyChooseUs from "./WhyChooseUs.js";
import Pricing from "./WmsPricing.js"

const HomeAppLanding = () => {
  return (
    <Layout>
      <PageMeta
        title="Vehicle Workshop Management Software | SenerTech - Simplify Garage Operations"
        desc="Streamline your garage operations with SenerTech's Vehicle Workshop Management Software. Manage appointments, track repairs, and enhance customer service efficiently."
      />
      <NavbarTop />
      <NavbarWms navDark />
      <HeroSeventeen />
      <SassMarketingFeature />
      <WmsCard />
      <Features />
      <WhyChooseUs />
      <Pricing/>
      <Subscription />
      <HelpDeskFaq />
      {/* <FooterSocial /> */}
      <FooterOne />
    </Layout>
  );
};

export default HomeAppLanding;
